export type ClientPlatform = "web" | "mobile" | "desktop";

export function detectPlatform(): ClientPlatform {
  if (typeof window !== "undefined") {
    if ((window as unknown as { __TAURI__?: unknown }).__TAURI__) {
      return "desktop";
    }
    if ((window as unknown as { Capacitor?: unknown }).Capacitor) {
      return "mobile";
    }
  }
  return "web";
}

export const CLIENT_PLATFORM: ClientPlatform =
  (import.meta.env.VITE_CLIENT_PLATFORM as ClientPlatform | undefined) ?? detectPlatform();

export const APP_VERSION =
  import.meta.env.VITE_APP_VERSION ??
  import.meta.env.VITE_COMMIT_SHA ??
  "dev";

export const DEFAULT_DEVICE_LABEL =
  typeof navigator !== "undefined"
    ? navigator.platform || "web-browser"
    : "web-browser";
